/* eslint-disable react/no-array-index-key */
import React from 'react'
import { arrayOf, shape, string } from 'prop-types'
import './index.scss'

const CategoryArticles = ({
  contents, name, type, moduleId,
}) => (
  <div
    className="category-articles wrapper"
    data-module={name}
    data-module-name={name}
    data-module-id={moduleId}
    data-module-type={type}
  >
    {contents.map((content, index) => (
      <div
        className="rich-text"
        key={index}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: content.content,
        }}
      />
    ))}
  </div>
)

CategoryArticles.propTypes = {
  contents: arrayOf(shape({})).isRequired,
  name: string,
  moduleId: string,
  type: string,
}

CategoryArticles.defaultProps = {
  name: null,
  moduleId: null,
  type: null,
}

export default CategoryArticles



// WEBPACK FOOTER //
// ./components/baby-club/category-articles/index.js